import React, { useState, forwardRef } from "react";
import { ReactNode } from "react";

interface LongPressableProps {
    onLongPress: () => void;
    onLongPressEnd?: () => void;
    onMouseLeave?: () => void;
    onMouseEnter?: () => void;
    children: ReactNode;
}

export const LongPressable = forwardRef<unknown, LongPressableProps>((props, ref) => {
    const [pressTimer, setPressTimer] = useState<ReturnType<typeof setTimeout> | null>(null);
    const [longPressTriggered, setLongPressTriggered] = useState<boolean>(false);

    const start = () => {
        setLongPressTriggered(false);
        setPressTimer(setTimeout(() => {
            setLongPressTriggered(true);
            props.onLongPress();
        }, 500));
    };

    const end = () => {
        if (pressTimer) {
            clearTimeout(pressTimer);
            setPressTimer(null);
            if (longPressTriggered && props.onLongPressEnd) {
                props.onLongPressEnd();
            }
        }
    };

    return React.cloneElement(props.children as any, {
        ref,
        onMouseDown: start,
        onMouseUp: end,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: ()=>{
            end()
            props.onMouseLeave?.()
        },
        onTouchStart: start,
        onTouchEnd: end,
    } as any);
});
